"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = require("react"),
    n = require("react-transition-group"),
    o = (e = require("clsx")) && "object" == typeof e && "default" in e ? e.default : e;

require("prop-types");

var r = require("react-dom");

function s() {
  return (s = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function i(e, t) {
  if (null == e) return {};
  var n,
      o,
      r = {},
      s = Object.keys(e);

  for (o = 0; o < s.length; o++) {
    t.indexOf(n = s[o]) >= 0 || (r[n] = e[n]);
  }

  return r;
}

function a(e) {
  return "number" == typeof e && !isNaN(e);
}

function u(e) {
  return "boolean" == typeof e;
}

function c(e) {
  return "string" == typeof e;
}

function l(e) {
  return "function" == typeof e;
}

function d(e) {
  return c(e) || l(e) ? e : null;
}

function f(e) {
  return 0 === e || e;
}

var p = !("undefined" == typeof window || !window.document || !window.document.createElement);

function m(e) {
  return t.isValidElement(e) || c(e) || l(e) || a(e);
}

var v,
    g,
    y = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center"
},
    T = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default",
  DARK: "dark"
};

function E(e, t, n) {
  void 0 === n && (n = 300);
  var o = e.scrollHeight,
      r = e.style;
  requestAnimationFrame(function () {
    r.minHeight = "initial", r.height = o + "px", r.transition = "all " + n + "ms", requestAnimationFrame(function () {
      r.height = "0", r.padding = "0", r.margin = "0", setTimeout(function () {
        return t();
      }, n);
    });
  });
}

function h(e) {
  var o,
      r,
      s = e.enter,
      a = e.exit,
      u = e.duration,
      c = void 0 === u ? 750 : u,
      l = e.appendPosition,
      d = void 0 !== l && l,
      f = e.collapse,
      p = void 0 === f || f,
      m = e.collapseDuration,
      v = void 0 === m ? 300 : m;
  return Array.isArray(c) && 2 === c.length ? (o = c[0], r = c[1]) : o = r = c, function (e) {
    var u = e.children,
        c = e.position,
        l = e.preventExitTransition,
        f = e.done,
        m = i(e, ["children", "position", "preventExitTransition", "done"]),
        g = d ? s + "--" + c : s,
        y = d ? a + "--" + c : a,
        T = function e() {
      var t = m.nodeRef.current;
      t && (t.removeEventListener("animationend", e), p ? E(t, f, v) : f());
    };

    return t.createElement(n.Transition, Object.assign({}, m, {
      timeout: l ? p ? v : 50 : {
        enter: o,
        exit: p ? r + v : r + 50
      },
      onEnter: function onEnter() {
        var e = m.nodeRef.current;
        e && (e.classList.add(g), e.style.animationFillMode = "forwards", e.style.animationDuration = o + "ms");
      },
      onEntered: function onEntered() {
        var e = m.nodeRef.current;
        e && (e.classList.remove(g), e.style.cssText = "");
      },
      onExit: l ? T : function () {
        var e = m.nodeRef.current;
        e && (e.classList.add(y), e.style.animationFillMode = "forwards", e.style.animationDuration = r + "ms", e.addEventListener("animationend", T));
      },
      unmountOnExit: !0
    }), u);
  };
}

!function (e) {
  e[e.COLLAPSE_DURATION = 300] = "COLLAPSE_DURATION", e[e.DEBOUNCE_DURATION = 50] = "DEBOUNCE_DURATION", e.CSS_NAMESPACE = "Toastify";
}(v || (v = {})), function (e) {
  e[e.Show = 0] = "Show", e[e.Clear = 1] = "Clear", e[e.DidMount = 2] = "DidMount", e[e.WillUnmount = 3] = "WillUnmount", e[e.Change = 4] = "Change", e[e.ClearWaitingQueue = 5] = "ClearWaitingQueue";
}(g || (g = {}));
var C = {
  list: new Map(),
  emitQueue: new Map(),
  on: function on(e, t) {
    return this.list.has(e) || this.list.set(e, []), this.list.get(e).push(t), this;
  },
  off: function off(e, t) {
    if (t) {
      var n = this.list.get(e).filter(function (e) {
        return e !== t;
      });
      return this.list.set(e, n), this;
    }

    return this.list.delete(e), this;
  },
  cancelEmit: function cancelEmit(e) {
    var t = this.emitQueue.get(e);
    return t && (t.forEach(function (e) {
      return clearTimeout(e);
    }), this.emitQueue.delete(e)), this;
  },
  emit: function emit(e) {
    for (var t = this, n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) {
      o[r - 1] = arguments[r];
    }

    this.list.has(e) && this.list.get(e).forEach(function (n) {
      var r = setTimeout(function () {
        n.apply(void 0, o);
      }, 0);
      t.emitQueue.has(e) || t.emitQueue.set(e, []), t.emitQueue.get(e).push(r);
    });
  }
};

function O(e, n) {
  void 0 === n && (n = !1);
  var o = t.useRef(e);
  return t.useEffect(function () {
    n && (o.current = e);
  }), o.current;
}

function b(e, t) {
  switch (t.type) {
    case "ADD":
      return [].concat(e, [t.toastId]).filter(function (e) {
        return e !== t.staleId;
      });

    case "REMOVE":
      return f(t.toastId) ? e.filter(function (e) {
        return e !== t.toastId;
      }) : [];
  }
}

function _(e) {
  var n = t.useReducer(function (e) {
    return e + 1;
  }, 0)[1],
      o = t.useReducer(b, []),
      r = o[0],
      s = o[1],
      p = t.useRef(null),
      v = O(0),
      g = O([]),
      y = O({}),
      T = O({
    toastKey: 1,
    displayedToast: 0,
    props: e,
    containerId: null,
    isToastActive: E,
    getToast: function getToast(e) {
      return y[e] || null;
    }
  });

  function E(e) {
    return -1 !== r.indexOf(e);
  }

  function h(e) {
    var t = e.containerId,
        n = T.props;
    n.limit && (!t || T.containerId === t && n.enableMultiContainer) && (v -= g.length, g = []);
  }

  function _(e) {
    var t = g.length;

    if ((v = f(e) ? v - 1 : v - T.displayedToast) < 0 && (v = 0), t > 0) {
      var n = f(e) ? 1 : T.props.limit;
      if (1 === t || 1 === n) T.displayedToast++, I();else {
        var o = n > t ? t : n;
        T.displayedToast = o;

        for (var r = 0; r < o; r++) {
          I();
        }
      }
    }

    s({
      type: "REMOVE",
      toastId: e
    });
  }

  function I() {
    var e = g.shift(),
        t = e.toastContent,
        n = e.toastProps,
        o = e.staleId;
    setTimeout(function () {
      S(t, n, o);
    }, 500);
  }

  function N(e, o) {
    var r = o.delay,
        s = o.staleId,
        f = i(o, ["delay", "staleId"]);

    if (m(e) && !function (e) {
      var t = e.updateId;
      return !!(!p.current || T.props.enableMultiContainer && e.containerId !== T.props.containerId || T.isToastActive(e.toastId) && null == t);
    }(f)) {
      var E = f.toastId,
          h = f.updateId,
          C = T.props,
          O = function O() {
        return _(E);
      },
          b = !(0, T.isToastActive)(E);

      b && v++;
      var I,
          N,
          A = {
        toastId: E,
        updateId: h,
        key: f.key || T.toastKey++,
        type: f.type,
        closeToast: O,
        closeButton: f.closeButton,
        rtl: C.rtl,
        position: f.position || C.position,
        transition: f.transition || C.transition,
        className: d(f.className || C.toastClassName),
        bodyClassName: d(f.bodyClassName || C.bodyClassName),
        style: f.style || C.toastStyle,
        bodyStyle: f.bodyStyle || C.bodyStyle,
        onClick: f.onClick || C.onClick,
        pauseOnHover: u(f.pauseOnHover) ? f.pauseOnHover : C.pauseOnHover,
        pauseOnFocusLoss: u(f.pauseOnFocusLoss) ? f.pauseOnFocusLoss : C.pauseOnFocusLoss,
        draggable: u(f.draggable) ? f.draggable : C.draggable,
        draggablePercent: a(f.draggablePercent) ? f.draggablePercent : C.draggablePercent,
        closeOnClick: u(f.closeOnClick) ? f.closeOnClick : C.closeOnClick,
        progressClassName: d(f.progressClassName || C.progressClassName),
        progressStyle: f.progressStyle || C.progressStyle,
        autoClose: (I = f.autoClose, N = C.autoClose, !1 === I || a(I) && I > 0 ? I : N),
        hideProgressBar: u(f.hideProgressBar) ? f.hideProgressBar : C.hideProgressBar,
        progress: f.progress,
        role: c(f.role) ? f.role : C.role,
        deleteToast: function deleteToast() {
          !function (e) {
            delete y[e], n();
          }(E);
        }
      };
      l(f.onOpen) && (A.onOpen = f.onOpen), l(f.onClose) && (A.onClose = f.onClose);
      var R = C.closeButton;
      !1 === f.closeButton || m(f.closeButton) ? R = f.closeButton : !0 === f.closeButton && (R = !m(C.closeButton) || C.closeButton), A.closeButton = R;
      var x = e;
      t.isValidElement(e) && !c(e.type) ? x = t.cloneElement(e, {
        closeToast: O
      }) : l(e) && (x = e({
        closeToast: O
      })), C.limit && C.limit > 0 && v > C.limit && b ? g.push({
        toastContent: x,
        toastProps: A,
        staleId: s
      }) : a(r) && r > 0 ? setTimeout(function () {
        S(x, A, s);
      }, r) : S(x, A, s);
    }
  }

  function S(e, t, n) {
    var o = t.toastId;
    y[o] = {
      content: e,
      props: t
    }, s({
      type: "ADD",
      toastId: o,
      staleId: n
    });
  }

  return t.useEffect(function () {
    return T.containerId = e.containerId, C.cancelEmit(3).on(0, N).on(1, function (e) {
      return p.current && _(e);
    }).on(5, h).emit(2, T), function () {
      return C.emit(3, T);
    };
  }, []), t.useEffect(function () {
    T.isToastActive = E, T.displayedToast = r.length, C.emit(4, r.length, e.containerId);
  }, [r]), t.useEffect(function () {
    T.props = e;
  }), {
    getToastToRender: function getToastToRender(t) {
      for (var n = {}, o = e.newestOnTop ? Object.keys(y).reverse() : Object.keys(y), r = 0; r < o.length; r++) {
        var s = y[o[r]],
            i = s.props.position;
        n[i] || (n[i] = []), n[i].push(s);
      }

      return Object.keys(n).map(function (e) {
        return t(e, n[e]);
      });
    },
    collection: y,
    containerRef: p,
    isToastActive: E
  };
}

function I(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function N(e) {
  var n = t.useState(!0),
      o = n[0],
      r = n[1],
      s = t.useState(!1),
      i = s[0],
      a = s[1],
      u = t.useRef(null),
      c = O({
    start: 0,
    x: 0,
    y: 0,
    deltaX: 0,
    removalDistance: 0,
    canCloseOnClick: !0,
    canDrag: !1,
    boundingRect: null
  }),
      d = O(e, !0),
      f = e.autoClose,
      p = e.pauseOnHover,
      m = e.closeToast,
      v = e.onClick,
      g = e.closeOnClick;

  function y(t) {
    var n = u.current;
    c.canCloseOnClick = !0, c.canDrag = !0, c.boundingRect = n.getBoundingClientRect(), n.style.transition = "", c.start = c.x = I(t.nativeEvent), c.removalDistance = n.offsetWidth * (e.draggablePercent / 100);
  }

  function T() {
    if (c.boundingRect) {
      var t = c.boundingRect;
      e.pauseOnHover && c.x >= t.left && c.x <= t.right && c.y >= t.top && c.y <= t.bottom ? h() : E();
    }
  }

  function E() {
    r(!0);
  }

  function h() {
    r(!1);
  }

  function C(e) {
    var t = u.current;
    c.canDrag && (o && h(), c.x = I(e), c.deltaX = c.x - c.start, c.y = function (e) {
      return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
    }(e), c.start !== c.x && (c.canCloseOnClick = !1), t.style.transform = "translateX(" + c.deltaX + "px)", t.style.opacity = "" + (1 - Math.abs(c.deltaX / c.removalDistance)));
  }

  function b() {
    var t = u.current;

    if (c.canDrag) {
      if (c.canDrag = !1, Math.abs(c.deltaX) > c.removalDistance) return a(!0), void e.closeToast();
      t.style.transition = "transform 0.2s, opacity 0.2s", t.style.transform = "translateX(0)", t.style.opacity = "1";
    }
  }

  t.useEffect(function () {
    return l(e.onOpen) && e.onOpen(t.isValidElement(e.children) && e.children.props), function () {
      l(d.onClose) && d.onClose(t.isValidElement(d.children) && d.children.props);
    };
  }, []), t.useEffect(function () {
    return e.draggable && (document.addEventListener("mousemove", C), document.addEventListener("mouseup", b), document.addEventListener("touchmove", C), document.addEventListener("touchend", b)), function () {
      e.draggable && (document.removeEventListener("mousemove", C), document.removeEventListener("mouseup", b), document.removeEventListener("touchmove", C), document.removeEventListener("touchend", b));
    };
  }, [e.draggable]), t.useEffect(function () {
    return e.pauseOnFocusLoss && (window.addEventListener("focus", E), window.addEventListener("blur", h)), function () {
      e.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", h));
    };
  }, [e.pauseOnFocusLoss]);
  var _ = {
    onMouseDown: y,
    onTouchStart: y,
    onMouseUp: T,
    onTouchEnd: T
  };
  return f && p && (_.onMouseEnter = h, _.onMouseLeave = E), g && (_.onClick = function (e) {
    v && v(e), c.canCloseOnClick && m();
  }), {
    playToast: E,
    pauseToast: h,
    isRunning: o,
    preventExitTransition: i,
    toastRef: u,
    eventHandlers: _
  };
}

function S(e) {
  var n = e.closeToast,
      o = e.ariaLabel;
  return t.createElement("button", {
    className: "Toastify__close-button Toastify__close-button--" + e.type,
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation(), n(e);
    },
    "aria-label": void 0 === o ? "close" : o
  }, t.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, t.createElement("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}

function A(e) {
  var n,
      r,
      i = e.closeToast,
      a = e.type,
      u = e.className,
      c = e.controlledProgress,
      d = e.progress,
      f = e.rtl,
      p = e.isIn,
      m = s({}, e.style, {
    animationDuration: e.delay + "ms",
    animationPlayState: e.isRunning ? "running" : "paused",
    opacity: e.hide ? 0 : 1
  });
  c && (m.transform = "scaleX(" + d + ")");
  var v = ["Toastify__progress-bar", c ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar--" + a, (n = {}, n["Toastify__progress-bar--rtl"] = f, n)],
      g = l(u) ? u({
    rtl: f,
    type: a,
    defaultClassName: o.apply(void 0, v)
  }) : o.apply(void 0, [].concat(v, [u])),
      y = ((r = {})[c && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"] = c && d < 1 ? null : function () {
    p && i();
  }, r);
  return t.createElement("div", Object.assign({
    className: g,
    style: m
  }, y));
}

A.defaultProps = {
  type: T.DEFAULT,
  hide: !1
};

var R = function R(e) {
  var n,
      r = N(e),
      s = r.isRunning,
      i = r.preventExitTransition,
      a = r.toastRef,
      u = r.eventHandlers,
      c = e.closeButton,
      d = e.children,
      f = e.autoClose,
      p = e.onClick,
      m = e.type,
      v = e.hideProgressBar,
      g = e.closeToast,
      y = e.transition,
      T = e.position,
      E = e.className,
      h = e.style,
      C = e.bodyClassName,
      O = e.bodyStyle,
      b = e.progressClassName,
      _ = e.progressStyle,
      I = e.updateId,
      S = e.role,
      R = e.progress,
      x = e.rtl,
      L = e.toastId,
      P = e.deleteToast,
      w = ["Toastify__toast", "Toastify__toast--" + m, (n = {}, n["Toastify__toast--rtl"] = x, n)],
      D = l(E) ? E({
    rtl: x,
    position: T,
    type: m,
    defaultClassName: o.apply(void 0, w)
  }) : o.apply(void 0, [].concat(w, [E])),
      M = !!R;
  return t.createElement(y, {
    in: e.in,
    appear: !0,
    done: P,
    position: T,
    preventExitTransition: i,
    nodeRef: a
  }, t.createElement("div", Object.assign({
    id: L,
    onClick: p,
    className: D || void 0
  }, u, {
    style: h,
    ref: a
  }), t.createElement("div", Object.assign({}, e.in && {
    role: S
  }, {
    className: l(C) ? C({
      type: m
    }) : o("Toastify__toast-body", C),
    style: O
  }), d), function (e) {
    if (e) {
      var n = {
        closeToast: g,
        type: m
      };
      return l(e) ? e(n) : t.isValidElement(e) ? t.cloneElement(e, n) : void 0;
    }
  }(c), (f || M) && t.createElement(A, Object.assign({}, I && !M ? {
    key: "pb-" + I
  } : {}, {
    rtl: x,
    delay: f,
    isRunning: s,
    isIn: e.in,
    closeToast: g,
    hide: v,
    type: m,
    style: _,
    className: b,
    controlledProgress: M,
    progress: R
  }))));
},
    x = h({
  enter: "Toastify__bounce-enter",
  exit: "Toastify__bounce-exit",
  appendPosition: !0
}),
    L = h({
  enter: "Toastify__slide-enter",
  exit: "Toastify__slide-exit",
  duration: [450, 750],
  appendPosition: !0
}),
    P = h({
  enter: "Toastify__zoom-enter",
  exit: "Toastify__zoom-exit"
}),
    w = h({
  enter: "Toastify__flip-enter",
  exit: "Toastify__flip-exit"
}),
    D = function D(e) {
  var n = e.children,
      o = e.className,
      r = e.style,
      s = i(e, ["children", "className", "style"]);
  return delete s.in, t.createElement("div", {
    className: o,
    style: r
  }, t.Children.map(n, function (e) {
    return t.cloneElement(e, s);
  }));
},
    M = function M(e) {
  var n = _(e),
      r = n.isToastActive,
      i = e.className,
      a = e.style,
      u = e.rtl;

  return t.createElement("div", {
    ref: n.containerRef,
    className: v.CSS_NAMESPACE,
    id: e.containerId
  }, (0, n.getToastToRender)(function (e, n) {
    var c,
        f,
        p = {
      className: l(i) ? i({
        position: e,
        rtl: u,
        defaultClassName: o(v.CSS_NAMESPACE + "__toast-container", v.CSS_NAMESPACE + "__toast-container--" + e, (c = {}, c[v.CSS_NAMESPACE + "__toast-container--rtl"] = u, c))
      }) : o(v.CSS_NAMESPACE + "__toast-container", v.CSS_NAMESPACE + "__toast-container--" + e, (f = {}, f[v.CSS_NAMESPACE + "__toast-container--rtl"] = u, f), d(i)),
      style: 0 === n.length ? s({}, a, {
        pointerEvents: "none"
      }) : s({}, a)
    };
    return t.createElement(D, Object.assign({}, p, {
      key: "container-" + e
    }), n.map(function (e) {
      var n = e.content,
          o = e.props;
      return t.createElement(R, Object.assign({}, o, {
        in: r(o.toastId),
        key: "toast-" + o.key,
        closeButton: !0 === o.closeButton ? S : o.closeButton
      }), n);
    }));
  }));
};

M.defaultProps = {
  position: y.BOTTOM_LEFT,
  transition: L,
  rtl: !1,
  autoClose: 3e3,
  hideProgressBar: !0,
  closeButton: S,
  pauseOnHover: !0,
  pauseOnFocusLoss: !0,
  closeOnClick: !0,
  newestOnTop: !1,
  draggable: !0,
  draggablePercent: 40,
  role: "alert"
};
var k,
    B,
    F,
    j = new Map(),
    U = [],
    H = !1;

function X() {
  return j.size > 0;
}

function Q() {
  return (Math.random().toString(36) + Date.now().toString(36)).substr(2, 10);
}

function W(e) {
  return e && (c(e.toastId) || a(e.toastId)) ? e.toastId : Q();
}

function q(e, n) {
  return X() ? C.emit(0, e, n) : (U.push({
    content: e,
    options: n
  }), H && p && (H = !1, B = document.createElement("div"), document.body.appendChild(B), r.render(t.createElement(M, Object.assign({}, F)), B))), n.toastId;
}

function V(e, t) {
  return s({}, t, {
    type: t && t.type || e,
    toastId: W(t)
  });
}

var z = function z(e, t) {
  return q(e, V(T.DEFAULT, t));
};

z.success = function (e, t) {
  return q(e, V(T.SUCCESS, t));
}, z.info = function (e, t) {
  return q(e, V(T.INFO, t));
}, z.error = function (e, t) {
  return q(e, V(T.ERROR, t));
}, z.warning = function (e, t) {
  return q(e, V(T.WARNING, t));
}, z.dark = function (e, t) {
  return q(e, V(T.DARK, t));
}, z.warn = z.warning, z.dismiss = function (e) {
  return X() && C.emit(1, e);
}, z.clearWaitingQueue = function (e) {
  return void 0 === e && (e = {}), X() && C.emit(5, e);
}, z.isActive = function (e) {
  var t = !1;
  return j.forEach(function (n) {
    n.isToastActive && n.isToastActive(e) && (t = !0);
  }), t;
}, z.update = function (e, t) {
  void 0 === t && (t = {}), setTimeout(function () {
    var n = function (e, t) {
      var n,
          o = (n = t.containerId, X() ? j.get(n || k) : null);
      return o ? o.getToast(e) : null;
    }(e, t);

    if (n) {
      var o = n.content,
          r = s({}, n.props, t, {
        toastId: t.toastId || e,
        updateId: Q()
      });
      r.toastId !== e && (r.staleId = e);
      var i = void 0 !== r.render ? r.render : o;
      delete r.render, q(i, r);
    }
  }, 0);
}, z.done = function (e) {
  z.update(e, {
    progress: 1
  });
}, z.onChange = function (e) {
  return l(e) && C.on(4, e), function () {
    l(e) && C.off(4, e);
  };
}, z.configure = function (e) {
  void 0 === e && (e = {}), H = !0, F = e;
}, z.POSITION = y, z.TYPE = T, C.on(2, function (e) {
  j.set(k = e.containerId || e, e), U.forEach(function (e) {
    C.emit(0, e.content, e.options);
  }), U = [];
}).on(3, function (e) {
  j.delete(e.containerId || e), 0 === j.size && C.off(0).off(1).off(5), p && B && document.body.removeChild(B);
}), exports.Bounce = x, exports.Flip = w, exports.Slide = L, exports.ToastContainer = M, exports.Zoom = P, exports.collapseToast = E, exports.cssTransition = h, exports.toast = z, exports.useToast = N, exports.useToastContainer = _;